export { Table } from '@snapchat/snap-design-system-marketing';
